'use client';

import { useEffect, useState } from 'react';
import dayjs from '@/common/dayjs';

// 補零到兩位數
const pad = (num: number) => String(num).padStart(2, '0');

// 計算距離今晚 23:59:59 剩餘的秒數
const getRemainingSeconds = () => {
    const end = dayjs().endOf('day');
    const diff = end.diff(dayjs(), 'second');
    return Math.max(diff, 0);
};

const DailyCountdown = () => {
    const [remaining, setRemaining] = useState(getRemainingSeconds);

    useEffect(() => {
        const timer = setInterval(() => {
            setRemaining(getRemainingSeconds());
        }, 60000);

        return () => clearInterval(timer);
    }, []);

    const hours = Math.floor(remaining / 3600);
    const minutes = Math.floor((remaining % 3600) / 60);
    // const seconds = remaining % 60;

    return (
        <span>
            {pad(hours)}:{pad(minutes)}
        </span>
    );
};

export default DailyCountdown;
